import { get, has, forOwn, mapKeys } from 'lodash/object'
import { isEmpty, isEqual, cloneDeep, isPlainObject } from 'lodash/lang'
import { includes, orderBy, sortBy } from 'lodash/collection'
import { uniqBy } from 'lodash/array'

// -----------------------------------------------------------------------------
// includesObject (<Array> array, <String> propertyName, <String> propertyValue, <Boolean> returnIndex)
// -----------------------------------------------------------------------------
function includesObject (array, propertyName = 'id', propertyValue, returnIndex = false) {
  let result = (returnIndex) ? -1 : false

  if (array && array.length > 0) {
    for (let i = 0; i < array.length; i++) {
      const entry = array[i]
      const hasProp = has(entry, propertyName)
      const valueToCheck = entry[propertyName]

      if (hasProp && valueToCheck === propertyValue) {
        result = (returnIndex) ? i : true
        break
      }
    } // end-for
  } // if (array && array.length > 0)

  return result
}

function mapKeysDeep (obj, fn) {
  const copy = {}

  forOwn(obj, (val, key) => {
    if (isPlainObject(val)) val = mapKeysDeep(val, fn)
    copy[fn(val, key)] = val
  })

  return copy
}

export default {
  get,
  has,
  mapKeys,
  isEmpty,
  isEqual,
  cloneDeep,
  isPlainObject,
  includes,
  orderBy,
  sortBy,
  uniqBy,
  includesObject,
  mapKeysDeep
}
